import { Caption } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/topupStyle';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IBodyProps {
	isError: boolean;
}

const Body = ({ isError }: IBodyProps) => {
	const classes = useStyles();

	return (
		<ConditionalRender
			show={isError}
			onTrue={() => (
				<div className={classes.dialogBody}>
					<Caption color="secondary-light" disableMargin>
						{translate('payments.topup.customerService')}
					</Caption>
				</div>
			)}
		/>
	);
};

export default Body;
